export enum pageNames {
  HOME = 'Home',
  RESEARCH = 'Research',
  RESEARCHEDITOR = 'ResearchEditor',
  RESEARCHEDITORNEW = 'ResearchEditorNew',
  RESEARCHEDITOREXISTING = 'ResearchEditorExisting',
  WRITER = 'Writer',
  WRITERNEWVIEW = 'WriterNewView',
  WRITEREDITORVIEW = 'WriterEditorView',
  FORGOTPASSWORD = 'ForgotPassword',
  RESETPASSWORD = 'ResetPassword',
  USERPROFILE = 'UserProfile',
  LOGIN = 'Login',
  LOGOUT = 'Logout'
}
